import sanitize from 'sanitize-html';

export function sanitizeInput(
  input: string,
  options: {} = {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'li', 'ol', 'ul'],
    allowedAttributes: {
      a: ['href', 'target'],
    },
  }
): string | null {
  if (typeof input === 'string') {
    // sanitize-html doesn't currently provide a way to whitelist '&' and we want to remove it across the board
    return sanitize(input, options)?.replace(/&amp;/g, '&');
  }

  return null;
}

export const noLinksSanitizeOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'p', 'br', 'li', 'ol', 'ul'],
  allowedAttributes: false,
};
